import { createDefaultDispatcher34z5li45gie67 as createDefaultDispatcher } from './CoroutineContext.mjs';
import { Unconfined_getInstance1ugsk82se1vaj as Unconfined_getInstance } from './Unconfined.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MainCoroutineDispatcher158x49bd8e9gp as MainCoroutineDispatcher } from './MainCoroutineDispatcher.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DispatchersClass;
function Dispatchers() {
  if (DispatchersClass === VOID) {
    class $ {
      constructor() {
        Dispatchers_instance = this;
        this.b14_1 = createDefaultDispatcher();
        this.c14_1 = Unconfined_getInstance();
        this.d14_1 = new (JsMainDispatcher())(this.b14_1, false);
        this.e14_1 = null;
      }
      f14() {
        var tmp0_elvis_lhs = this.e14_1;
        return tmp0_elvis_lhs == null ? this.d14_1 : tmp0_elvis_lhs;
      }
    }
    initMetadataForObject($, 'Dispatchers');
    DispatchersClass = $;
  }
  return DispatchersClass;
}
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance === VOID)
    new (Dispatchers())();
  return Dispatchers_instance;
}
var JsMainDispatcherClass;
function JsMainDispatcher() {
  if (JsMainDispatcherClass === VOID) {
    class $ extends MainCoroutineDispatcher() {
      constructor(delegate, invokeImmediately) {
        super();
        this.f1m_1 = delegate;
        this.g1m_1 = invokeImmediately;
        this.h1m_1 = this.g1m_1 ? this : new (JsMainDispatcher())(this.f1m_1, true);
      }
      c18() {
        return this.h1m_1;
      }
      q13(context) {
        return !this.g1m_1;
      }
      t13(context, block) {
        return this.f1m_1.t13(context, block);
      }
      toString() {
        var tmp0_elvis_lhs = this.d18();
        return tmp0_elvis_lhs == null ? this.f1m_1.toString() : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($, 'JsMainDispatcher');
    JsMainDispatcherClass = $;
  }
  return JsMainDispatcherClass;
}
//region block: exports
export {
  Dispatchers_getInstance as Dispatchers_getInstance128lm494a5r5s,
};
//endregion

//# sourceMappingURL=Dispatchers.mjs.map
